<template>
    <div class="SalesProductEntry" @mouseover="(event)=>{OnHover(event);}">
        <div class="ProductCodesContainer">
            <div class="ProductCode">{{ SerialNumber }}</div>
            <div class="ProductCode">{{ StyleNumber }}</div>
            <div class="ProductCode">{{ JAN }}</div>
        </div>
        <div class="ProductInfoContainer RoundShadowElement" :class="{ 'ProductSmall': IsDisplaySmallProducts}">
            <div v-if="IsDisplaySmallProducts === false" class="ProductFactory">{{ Factory }}</div>
            <div v-if="IsDisplaySmallProducts === false" class="ProductReleaseDate">{{ ReleaseDate }}</div>
            <div class="ProductName" :title="ProductName">{{ ProductName }}</div>
            <div v-if="IsDisplaySmallProducts === false" class="ProductCost" title="原価">¥{{ Cost }}</div>
            <div v-if="IsDisplaySmallProducts === false" class="ProductPrice" title="上代">¥{{ Price }}</div>
            <div v-if="IsDisplaySmallProducts === false" class="ProductSallerPrice" title="問屋/値引販売">¥{{ WholesalerPrice }}</div>
        </div>
    </div>
</template>

<script>
export default
{
    props: {
        IsDisplaySmallProducts: Boolean,
        SerialNumber: String,
        StyleNumber: String,
        JAN: String,
        Factory: String,
        ReleaseDate: String,
        Cost: Number,
        Price: Number,
        WholesalerPrice: Number,
        ProductName: String,
        OnHover: Function,
    }
}

</script>

<style>

</style>